import React from 'react';
import { styled } from 'styled-components';
import CopyToClipboard from './CopyToClipboard.js';
import Link2 from './Icons/Link2.js';
const CaseReferenceId = (props) => props.referenceId ? (React.createElement(StyledCaseReferenceId, { ...props },
    React.createElement(CopyToClipboard, { text: props.referenceId },
        React.createElement("span", { onClick: () => {
                if (props.erpLink && props.referenceId) {
                    const url = props.erpLink.replace('{{customerReferenceId}}', props.referenceId);
                    window.open(url, '_blank');
                }
            } },
            props.referenceId,
            ' ',
            props.erpLink && props.referenceId && (React.createElement(Link2, { style: {
                    margin: '0.3em 0 -0.3em',
                    width: '16px',
                    height: '16px',
                } })))))) : null;
export default CaseReferenceId;
const StyledCaseReferenceId = styled.div `
  font-size: 0.8em;
  margin-top: 0.5em;

  ${(props) => (props.erpLink && props.referenceId ? 'cursor: pointer;' : '')}

  svg {
    margin: 3px 0 -3px 0;
  }

  span {
    font-family: 'Courier New', Courier, monospace !important;
    font-weight: bold;
  }
`;
//# sourceMappingURL=CaseReferenceId.js.map